import { mapActions } from 'vuex';
import contentHeader from '@/components/generics/content-header/content-header.vue';
import catchHtmlClickMixin from '@/helpers/catchHtmlClickMixin';
import faq from '@/components/support/faq/faq.vue';
import supportMixin from '@/mixins/support';
import cmsContentMixin from '@/mixins/cmsContent';
import { STATIC_PAGES } from '@/constants';


const DEFAULT_TITLE = 'How to Trade on PredictIt';

export default {
  mixins: [
    catchHtmlClickMixin,
    cmsContentMixin,
    supportMixin,
  ],
  props: {
    title: {
      type: String,
      default: DEFAULT_TITLE,
    },
  },
  components: {
    contentHeader,
    faq,
  },
  methods: {
    ...mapActions('browse', ['getStaticPageFull']),
  },
  metaInfo() {
    return {
      title: 'Support',
    };
  },
  created() {
    this.getStaticPageFull(STATIC_PAGES.HOW_TO_TRADE)
      .then((data) => {
        this.installDynamicControls({ data });
      });
  },
};



// WEBPACK FOOTER //
// ./src/components/support/learn-the-basics/learn-the-basics.js